
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

function Center({...props }) {
 const [dataa,setdataa]=useState([])

    const getData = async () => {

   


        const sendData = {
            
            UserId: props.userId,
           

        }
        //console.log(sendData)


        await fetch(process.env.REACT_APP_API_LINK +'api/Data/Usercenter', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data)
                    setdataa(data)

                    
                })
    };
    useEffect(() => {
        getData()
    }, [])

    return (<>

        <td> <b style={{ fontSize: 18 }}>{dataa.name}</b></td>

    </>
    );
};

export default Center;
